const links = {
    vapp: {
        rdWeb: "https://go.vapp.cl/RDWeb/webclient",
        publicSite: process.env.VUE_APP_PUBLIC_URL,
        edigReturnUrl: `${process.env.VUE_APP_PUBLIC_URL}/#/edig`,
    },
    soporte: {
        zohoTickets: "https://desk.zoho.com/portal/vapps/es/signin",
        zendeskEdig: "https://edig.zendesk.com/hc/es/requests/new",
        anydeskDownload: "https://download.anydesk.com/AnyDesk.exe",
    },
    crm: {
        zohoWebToLead: "https://crm.zoho.com/crm/WebToLeadForm",
        zohoAnalyticsTracker: "https://crm.zohopublic.com/crm/WebFormAnalyticsServlet?rid=786c9b916bcaa377d071c5d975bd04da1e279152eb5244e71bdad0b5ecf472c6gid85cf64b4563be8a1ac04a0934e743ac0a01c0fa4b55e1ddb70f464b1ecc83e50gida378f81585080d3b6fb1acbec6638b71gid885e3c1045bd9bdcc91bdf30f82b5696gid14f4ec16431e0686150daa43f3210513",
    },
    redes: {
        youtubeChannel: "https://www.youtube.com/channel/UCjdBQlbq2i2jsDKMbIyr53w",
        instagram: "https://www.instagram.com/vapp_chile/",
    },
    tutoriales: {
        ingresoEscritorio: "https://www.youtube.com/embed/IdAr777Tgtk",
        ingresoWeb: "https://www.youtube.com/embed/-m90Vbe95Uk",
    },
    referencias: {
        nortonRansomware: "https://cl.norton.com/internetsecurity-malware-ransomware-5-dos-and-donts.html?inid=nortoncom_isc_homepage_carousel_slot3_internetsecurity-malware-ransomware-5-dos-and-donts",
        gobPlanEconomico: "https://www.gob.cl/planeconomicoemergencia/",
    },
};

export default {
    appName: "Vapp",
    version: "2.0",
    protocol: process.env.VUE_APP_API_PROTOCOL || "https",
    ipServer: process.env.VUE_APP_API_HOST,
    gaelApi: process.env.VUE_APP_GAEL_API,
    links,
};
